jQuery( document ).ready(function($) {    

  /* Product slider */
  $('.product-slider-single').slick({
      rows: 1,
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            
          }
        },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              
            }
          },

          { 
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              
            }
          },
        ]
  });

  $('.product-slider-double').slick({
    rows: 2,
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          
        }
      },
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            
          }
        },

        { 
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            
          }
        },
      ]
});
  

});
